
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Added new patterns to Figma `}<a parentName="p" {...{
        "href": "https://www.figma.com/community/file/926189711301522231"
      }}>{`Design Pattern library`}</a>{`, updates to allow authentication workflow customizations, overhauled dark themes, new CLI templates, and our first PX Blue `}<a parentName="p" {...{
        "href": "https://www.youtube.com/watch?v=CESJ9BKLWco"
      }}>{`training video`}</a>{`!`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;